import React from 'react';
import Grid from '@mui/material/Grid';
import Title from '../Typography/Title.js';
import { TitleFontSize } from '../Typography/types.js';
import { IllustratedMessageVariant } from './types.js';
import { styled } from '@mui/material/styles';
const Content = ({ variant, title, titleProps = { fontSize: TitleFontSize.Small }, children, }) => {
    return (React.createElement(StyledGridItem, { item: true, xs: true, ...(variant === IllustratedMessageVariant.Vertical ? { textAlign: 'center' } : {}), "data-testid": "illustrated-message-content" },
        title ? (React.createElement(Title, { ...titleProps, mb: 1, "data-testid": "illustrated-message-title" }, title)) : null,
        children));
};
const StyledGridItem = styled(Grid)(() => ({
    textWrap: 'balance',
}));
export default Content;
